import {useGetUserQuery} from 'modules/user/services';

export const useIsLoggedIn = () => {
    const {data} = useGetUserQuery();
    return Boolean(data?.isAuthorized);
};
